import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { WorkflowComponent } from './workflow/workflow.component';
import { WorkflowHotspotCreatorComponent } from './workflow/workflow-hotspot-creator/workflow-hotspot-creator.component';
import { WorkflowValidationUploadComponent } from './workflow/workflow-validation-upload/workflow-validation-upload.component';
import { InprocessComponent } from './inprocess/inprocess.component';
import { ProvidedComponent } from './provided/provided.component';
import { ContactComponent } from './contact/contact.component';
import { WorkflowStepDriversManualComponent } from './workflow/workflow-step-drivers-manual/workflow-step-drivers-manual.component';
import { WorkflowStepAppAssetsComponent } from './workflow/workflow-step-app-assets/workflow-step-app-assets.component';
import {WorkflowStepDisclaimerComponent} from './workflow/workflow-step-disclaimer/workflow-step-disclaimer.component';
import {WorkflowHotspotDotSetterComponent} from './workflow/workflow-hotspot-creator/workflow-hotspot-dot-setter/workflow-hotspot-dot-setter.component';
import {AuthGuard} from './service/auth/auth.guard';
import {LoginComponent} from './login/login.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'upload/drivers-manual',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
      path: 'upload',
      component: WorkflowComponent,
      canActivate: [AuthGuard],
      children: [
          {path: 'drivers-manual', component: WorkflowStepDriversManualComponent, canActivate: [AuthGuard]},
          {path: 'disclaimer', component: WorkflowStepDisclaimerComponent, canActivate: [AuthGuard]},
          {path: 'app-assets', component: WorkflowStepAppAssetsComponent, canActivate: [AuthGuard]},
          {path: 'hotspot-creator', component: WorkflowHotspotCreatorComponent, canActivate: [AuthGuard]},
          {path: 'hotspot-dots/:id', component: WorkflowHotspotDotSetterComponent, canActivate: [AuthGuard]},
          {path: 'validation-upload', component: WorkflowValidationUploadComponent, canActivate: [AuthGuard]},
      ]
  },
  {
    path: 'inprocess',
    component: InprocessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'provided',
    component: ProvidedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      //{ enableTracing: true }) // <-- debugging purposes only
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
